import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import LoaderComponent from "../Loader";
import Close from "@material-ui/icons/Close";
import GridItem from "../Grid/GridItem.jsx";

import confirmationModalStyle from "../../../assets/jss/user/confirmationModalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const ConfirmationModal = class extends React.Component {
    renderErrorMessages(){
        const { errorMessage } = this.props;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<GridItem key={key} className={"passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </GridItem>);
                key++;
            }
            return errorMessages;
        }
        return <GridItem className={"passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </GridItem>;
    }
    render() {
        const { classes, saving, confirmationMessage, cancelButtonText, successButtonText, success, successMessage, showError } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="confirmationModal-modal-slide-title"
                aria-describedby="confirmationModal-modal-slide-description"
            >
                <DialogTitle
                    id="confirmationModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                >
                    <Button
                        simple
                        className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.props.onClose()}
                    >
                        {
                            saving ?
                                <></>
                            :
                                <Close className={classes.modalClose} />
                        }
                    </Button>
                    {
                        saving ?
                            <></>
                        : success && successMessage !== "" ?
                            <h4 className={classes.modalTitle}>{successMessage}</h4> 
                        :
                            <h4 className={classes.modalTitle}>{confirmationMessage}</h4> 
                    }
                </DialogTitle>
                <DialogContent
                    id="confirmationModal-modal-slide-description"
                    className={classes.modalBody}
                >
                    {
                        showError ?
                            this.renderErrorMessages()
                        :
                            <></>
                    }
                    {
                        saving ?        
                            <LoaderComponent color="custom" align="center" />
                        :
                            <></>
                    }
                </DialogContent>
                <DialogActions className={classes.modalFooter}>
                    {
                        success ? 
                            <Button color="white" onClick={() => this.props.onClose()}>
                                Close
                            </Button>
                        : saving === false ?
                            <>
                                <Button color="custom" className={classes.rightButton} onClick={() => this.props.onSuccess(false)} >
                                    {successButtonText}
                                </Button>
                                <Button color="white" onClick={() => this.props.onClose()}>
                                    {cancelButtonText}
                                </Button>
                            </>
                        :
                            <></>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

ConfirmationModal.defaultProps = {
    open: false,
    confirmationMessage: "",
    saving: false,
    cancelButtonText: "Cancel",
    successButtonText: "Yes",
    successMessage: "",
    success: false,
    errorMessage: '',
    showError: false
}
ConfirmationModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    confirmationMessage: PropTypes.string,
    saving: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    successButtonText: PropTypes.string,
    successMessage: PropTypes.string,
    success: PropTypes.bool,
}
export default withStyles(confirmationModalStyle)(ConfirmationModal);